import { ApolloClient, ApolloLink, InMemoryCache, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import { SUBSCRIPTION_LINK, UPLOAD_LINK } from "../config";
import { TOKEN_ASYNC_STORAGE } from "../common/constants";
import { createClient } from 'graphql-ws';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from "@apollo/client/utilities";
import { RetryLink } from '@apollo/client/link/retry';

const wsLink = new GraphQLWsLink(
  createClient({
    url: SUBSCRIPTION_LINK,
    async connectionParams() {
      const token = localStorage.getItem(TOKEN_ASYNC_STORAGE);
      return {
        Authorization: `Bearer ${token}`,
      };
    },
    retryAttempts: 5,
    shouldRetry: (errorOrCloseEvent) => {
      console.log('WebSocket connection error:', errorOrCloseEvent);
      return true;
    },
  }),
);

const link = createUploadLink({
  uri: UPLOAD_LINK,
});

export function death() {
  localStorage.clear();
  window.location.href = "/login";
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  console.log('graphQLErrors:', graphQLErrors);
  console.log('networkError:', networkError);
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      switch (err.message) {
        case 'Unauthorized':
          death();
          break;
        }
      break;
    }
  }
});

const auth_link = setContext((_, { headers }) => {
  const localToken = localStorage.getItem(TOKEN_ASYNC_STORAGE)
  return {
    headers: {
      ...headers,
      Authorization: localToken ? `Bearer ${localToken}` : "",
    },
  };
});

const retryLink = new RetryLink({
  delay: {
    initial: 500,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 5,
    retryIf: (error, _operation) => {
      return !!error;
    },
  },
});

const splitLink = split(
  ({query}) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  auth_link.concat(retryLink.concat(wsLink)),
  auth_link.concat(retryLink.concat(link)),
);

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, splitLink]),
  cache: new InMemoryCache(),
});
